import styled from 'styled-components/native'

import { Box } from 'widgets/Box'

export const StepContainer = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
`
